import { store } from '../store';

// Holds a single in-progress "/try" design across the trip to /register and
// back — there's only ever one guest session at a time, so a fixed key is fine.
export const GUEST_DESIGN_KEY = 'tunify_guest_design';
const FILE_VERSION = 1;

// Same saved-design shape used everywhere else (Builder/RoomEditor/House3DView's
// handleWebSave, App.jsx's handleSaveAndLeave) — kept in sync with those by hand
// since none of them export a shared builder function.
export function saveGuestDesign() {
  const s = store.getState().house;
  const design = {
    version: FILE_VERSION, savedAt: new Date().toISOString(),
    phase: 'build', rooms: s.rooms, designs: s.designs, furniture: s.furniture, lighting: s.lighting || [],
    wallSegments: s.wallSegments || [], autoWallOpenings: s.autoWallOpenings || {},
    wallHeight: s.wallHeight ?? 2.8, nextId: s.nextId,
    nextFurnitureId: s.nextFurnitureId, nextLightingId: s.nextLightingId || 1, nextOpeningId: s.nextOpeningId,
    nextWallId: s.nextWallId || 1, nextWallOpeningId: s.nextWallOpeningId || 1,
  };
  try {
    localStorage.setItem(GUEST_DESIGN_KEY, JSON.stringify(design));
  } catch {
    // localStorage unavailable (private browsing, quota, etc.) — nothing to
    // fall back to here; the post-registration flow will just start blank.
  }
}

export function loadGuestDesign() {
  try {
    const raw = localStorage.getItem(GUEST_DESIGN_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.version === FILE_VERSION ? parsed : null;
  } catch {
    return null;
  }
}

export function clearGuestDesign() {
  try { localStorage.removeItem(GUEST_DESIGN_KEY); } catch { /* ignore */ }
}

export function hasGuestDesign() {
  try { return !!localStorage.getItem(GUEST_DESIGN_KEY); } catch { return false; }
}
